import { useQuery } from '@tanstack/react-query'

import { layoutService } from '../app/services/layout.service'

export const accessibleBranchesQueryKey = ['accessible-branches'] as const

export function useAccessibleBranches(enabled: boolean) {
  return useQuery({
    queryKey: accessibleBranchesQueryKey,
    queryFn: () => layoutService.getMySucursales(),
    enabled,
    staleTime: 60_000,
  })
}
